.content {
  background: white;
  position: absolute;
  top: 3.75em;
  left: calc(100% + 0.25em);
  padding: 0.35em;
  z-index: 1;
  max-height: 280px;
  overflow-y: scroll;
  margin-top: 0 !important;
}
